/**
 * Pre-compiled pt-BR messages for Select
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearSelection: `Limpar seleção` };
